<template>
	<el-tiptap
		class="u__padding-20 max-width"
		:extensions="extensions"
		:content="content"
		placeholder="Opis"
		@onUpdate="updateContent"
		:readonly="readonly"
	/>
</template>

<script>
import {
	Doc,
	Text,
	Paragraph,
	Heading,
	Bold,
	Italic,
	Underline,
	Strike,
	Blockquote,
	TextAlign,
	History
} from 'element-tiptap'

export default {
	name: 'Editor',
	props: {
		content: {
			type: String,
			default: ''
		},
		readonly: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		extensions: [
			new Doc(),
			new Text(),
			new Paragraph(),
			new Heading({ level: 1 }),
			new Bold(),
			new Italic(),
			new Underline(),
			new Strike(),
			new Blockquote(),
			new TextAlign(),
			new History()
		]
	}),
	methods: {
		updateContent(val) {
			this.$emit('update-content', val)
		}
	}
}
</script>
